module.exports = __webpack_public_path__ + "img/progressBar-notStarted.096deb24.png";